import { Modal, ModalProps, message as antdMessage } from 'antd';
import { LocalMessage } from 'hooks/business/conversation';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { noop } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { reportCase } from 'services/api/feedback';
import FeedbackForm from './FeedbackForm';
import { feedbackFormValues2submitValues } from './utils';

export interface FeedbackModal extends ModalProps {
  message: LocalMessage;
  storeName?: string;
}

function Feedback(props: FeedbackModal) {
  const { message, storeName, onCancel = noop, ...otherProps } = props;

  const { t } = useTranslate();

  const userLanguage = useSystemLanguageValue();

  const caseType = message.msgFromType === 'BUYER' ? 'UN_ANSWERED' : 'WRONG_ANSWER';

  const title = {
    UN_ANSWERED: t('scene.chatWorkspace.feedbackDialog.title.unanswered'),
    WRONG_ANSWER: t('scene.chatWorkspace.feedbackDialog.title.wrongAnswer'),
  }[caseType];

  return (
    <FeedbackForm
      storeName={storeName}
      initialValues={{
        caseType,
        message,
        userLanguage,
        caseCategory: undefined,
        reason: undefined,
      }}
      onSubmit={(values, helpers) => {
        return reportCase(feedbackFormValues2submitValues(values))
          .then(() => {
            onCancel();

            antdMessage.success(t('scene.chatWorkspace.feedbackDialog.feedback.submitSuccess'));

            helpers.resetForm();
          })
          .catch(() => {
            antdMessage.error(t('scene.chatWorkspace.feedbackDialog.feedback.submitFailed'));
          });
      }}
    >
      {(form, props) => {
        const { isSubmitting, handleSubmit } = props;

        return (
          <Modal
            {...otherProps}
            onCancel={onCancel}
            width={600}
            title={title}
            okText={t('scene.chatWorkspace.feedbackDialog.action.submit')}
            okButtonProps={{
              loading: isSubmitting,
              onClick: () => handleSubmit(),
            }}
            zIndex={99999}
          >
            {form}
          </Modal>
        );
      }}
    </FeedbackForm>
  );
}

export default Feedback;
